import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Grid, Box, Typography } from "@mui/material";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import MetricCard from "../../components/MetricCard/MetricCard";
import SellOutAnoCard from "./components/SellOutAnoCard";
import PerformaceRegionalCard from "./components/PerformaceRegionalCard";
import PerformanceGrupoCard from "./components/PerformaceGrupoCard";
import { Footer } from "../../components/Footer/Footer";

function OverviewDesktop({ app, config }) {
  const variables = [
    "vTexto_SellOut_kpi",
    "vTexto_Cobertura",
    "vTexto_ROS",
    "vTexto_Quali"
  ];
  const [variableTitles, setVariableTitles] = useState({});

  useEffect(() => {
    let isMounted = true;
    let variableModels = {};

    const updateVariableTitle = async (variableName) => {
      try {
        const variableModel = await app.variable.getByName(variableName);
        const layout = await variableModel.getLayout();
        if (isMounted) {
          setVariableTitles((prev) => ({ ...prev, [variableName]: layout.qText }));
        }
      } catch (error) {
        console.error(`Erro ao obter a variável ${variableName}:`, error);
      }
    };

    variables.forEach(async (variableName) => {
      await updateVariableTitle(variableName);
      try {
        const variableModel = await app.variable.getByName(variableName);
        variableModel.on("changed", () => updateVariableTitle(variableName));
        variableModels[variableName] = variableModel;
      } catch (error) {
        console.error(`Erro ao adicionar listener para ${variableName}:`, error);
      }
    });

    return () => {
      isMounted = false;
      Object.values(variableModels).forEach((model) => model?.removeListener("changed", updateVariableTitle));
    };
  }, [app]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container sx={{ marginTop: "37px" }}>
            <Box className="container-card-title">
              <Typography variant="h1" className="title">
                Performance indireto e LC
              </Typography>
            </Box>
            <Grid container spacing={2} sx={{ marginBottom: "24px" }}>
              <Grid item xs={12} md={6} lg={3}>
                <MetricCard
                  app={app}
                  nameCard={variableTitles["vTexto_SellOut_kpi"]}
                  objectIds={{
                    porcente: "eBtky",
                    metric01: "HUyFuwm",
                    metric02: "pMQcMSa",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MetricCard
                  app={app}
                  nameCard={variableTitles["vTexto_Cobertura"]}
                  objectIds={{
                    porcente: "HWFP",
                    metric01: "tmwVT",
                    metric02: "XzyCFh",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MetricCard
                  app={app}
                  nameCard={variableTitles["vTexto_ROS"]}
                  objectIds={{
                    porcente: "pjCXTP",
                    metric01: "vJXmUr",
                    metric02: "NWwjKXr",
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MetricCard
                  app={app}
                  nameCard={variableTitles["vTexto_Quali"]}
                  objectIds={{
                    porcente: "bkgAX",
                    metric01: "auzVT",
                    metric02: "yRjyj",
                  }}
                />
              </Grid>
            </Grid>
            <Grid container>
              <SellOutAnoCard app={app} />
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: "24px" }}>
              <Grid item xs={12} md={6}>
                <PerformaceRegionalCard app={app} />
              </Grid>
              <Grid item xs={12} md={6}>
                <PerformanceGrupoCard app={app} />
              </Grid>
            </Grid>
          </Grid>
          <Footer app={app} />
        </LayoutWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
